import { Button, Typography, Space } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import consts from "../../constant";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

export default function Page404() {

  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#000',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '600px', width: '100%' }}>
        <Title
          style={{
            fontSize: "clamp(80px, 15vw, 150px)",
            margin: 0,
            color: "#FC4420",
            textShadow: "0 0 20px rgba(131, 228, 174, 0.4)",
            lineHeight: 1
          }}
        >
          404
        </Title>

        <Title level={2} style={{ color: "#fff", marginTop: '20px', fontSize: 'clamp(24px, 4vw, 36px)' }}>
          Page Not Found!
        </Title>

        <Text style={{ color: "#FC4420", fontSize: "clamp(14px, 2vw, 16px)", display: 'block', marginBottom: '40px', opacity: 0.8 }}>
          Sorry we can't seem to find the page you're looking for. It might be an old link or maybe it moved.
        </Text>

        <div style={{ marginTop: "30px", display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            type="primary"
            size="large"
            icon={<HomeOutlined />}
            onClick={() => navigate(`/${consts.route}`)}
            style={{
              background: "#03321E",
              borderColor: "#83e4ae",
              color: "#83e4ae",
              borderRadius: '8px',
              height: '48px',
              padding: '0 30px'
            }}
          >
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
}
